import { render, staticRenderFns } from "./CategoriesList.vue?vue&type=template&id=73ef8e53&scoped=true"
import script from "./CategoriesList.vue?vue&type=script&lang=ts"
export * from "./CategoriesList.vue?vue&type=script&lang=ts"
import style0 from "./CategoriesList.vue?vue&type=style&index=0&id=73ef8e53&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ef8e53",
  null
  
)

export default component.exports